import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EventListDto,
  EventTypeListDto,
  PortListDto,
} from "~/api/GeneratedApi";
import { VesselMapItem } from "~/pages/MapPage/types/mapItems";
import { RootState } from "../store/store";

// Define a type for the slice state
interface DataState {
  ports: PortListDto[] | null;
  vessels: VesselMapItem[] | null;
  events: EventListDto[] | null;
  eventTypes: EventTypeListDto[] | null;
}

// Define the initial state using that type
const initialState: DataState = {
  ports: null,
  vessels: null,
  events: null,
  eventTypes: null,
};

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setPorts: (state, action: PayloadAction<PortListDto[] | null>) => {
      state.ports = action.payload;
    },
    setVessels: (state, action: PayloadAction<VesselMapItem[] | null>) => {
      state.vessels = action.payload;
    },
    setEvents: (state, action: PayloadAction<EventListDto[] | null>) => {
      state.events = action.payload;
    },
    setEventTypes: (
      state,
      action: PayloadAction<EventTypeListDto[] | null>,
    ) => {
      state.eventTypes = action.payload;
    },
  },
});

export const { setPorts, setEvents, setEventTypes, setVessels } =
  dataSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectPorts = (state: RootState): PortListDto[] | null =>
  state.data.ports;

export default dataSlice.reducer;
